import { useMemo } from "react";
import type { CatalogTagOption } from "sj-ui-toolkit/src/client/svcContent";

export interface MappedCweTag {
  value: number;
  name: string;
  description: string | null;
}

// svc-content returns CWE metadata inline
export const useCweTags = (tagsData: Record<string, CatalogTagOption[]>): MappedCweTag[] =>
  useMemo(
    () =>
      (tagsData.cwe ?? [])
        .map(cwe => ({
          value: parseInt(cwe.id ?? "", 10),
          name: cwe.displayName || `CWE-${cwe.id}`,
          description: cwe.description ?? null,
        }))
        .filter(t => !isNaN(t.value)),
    [tagsData.cwe]
  );
